export default __webpack_public_path__ + "static/media/vu.f6d716ab.svg";